import React, { useContext, useState, useEffect } from "react";
import "./Dashboard.css";
import Buckets from "../Common_Component/Buckets/Buckets";
import Table_Heading from "../Common_Component/Table_Heading/Table_Heading";
import New_User_Table from "./New_User_Table/New_User_Table";
import { Form, Table } from "react-bootstrap";
import Border_btn from "../Common_Component/Border_btn/Border_btn";
import { Context } from "../../utils/context";
import { findAll } from "../../utils/apis/dashboard/dashboard";
import Pei_Chart from "../Common_Component/Pei_Chart/Pei_Chart";
import Donut_Chart from "../Common_Component/Donut_Chart/Donut_Chart";
import Polar_Area_Chart from "../Common_Component/Polar_Area_Chart/Polar_Area_Chart";
import { Link } from "react-router-dom";
import Heading_Holder from "../Common_Component/Heading_Holder/Heading_Holder";
import { formatAmount } from "../../utils/common";

function Dashboard() {
  const { UnauthorizedLogOut, userdata } = useContext(Context);

  console.log(userdata, "userdata");

  const [data, setData] = useState([]);
  const getDataAll = async () => {
    try {
      const response = await findAll();
      await setData(response?.data);
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };
  useEffect(() => {
    getDataAll();
  }, []);

  const today = new Date().toISOString().split("T")[0];

  const bucketData = [
    {
      BucketText: "Total Customers",
      divText: data?.data?.total_users || 0,
      api: "/agent-management/customer",
      bgColor: "rgba(255, 99, 132, 0.45)", // Pink
    },

    {
      BucketText: "Total In-Active Customers",
      divText: data?.data?.total_inactive_users || 0,
      api: "/agent-management/customer?status=0",
      bgColor: "rgba(255, 206, 86, 0.45)",
    },

    ...(userdata?.role_id == 1
      ? [
          {
            BucketText: "Total Super Super Master",
            divText: data?.data?.total_super_super_master || 0,
            api: "/agent-management/super-super-master",
            bgColor: "rgba(15, 184, 105, 0.45)",
          },
        ]
      : []),

    // Role 1 and 2
    ...(userdata?.role_id == 1 || userdata?.role_id == 2
      ? [
          {
            BucketText: "Total Super Master",
            divText: data?.data?.total_super_master || 0,
            api: "/agent-management/super-master",
            bgColor: "rgba(126, 12, 97, 0.45)",
          },
        ]
      : []),

    // Role 1, 2 and 3
    ...(userdata?.role_id == 1 ||
    userdata?.role_id == 2 ||
    userdata?.role_id == 3
      ? [
          {
            BucketText: "Total Master",
            divText: data?.data?.total_master || 0,
            api: "/agent-management/master",
            bgColor: "rgba(23, 116, 236, 0.45)",
          },
        ]
      : []),
    ...(userdata?.role_id == 1
      ? [
          {
            BucketText: "Total Matka Bits",
            divText: formatAmount(data?.data?.total_matka_bit_amount) || 0,
            api: `/matka-bid-history`,
            bgColor: "rgba(247, 5, 5, 0.45)", // Green
          },
        ]
      : []),

    {
      BucketText: "My Wallet Amount",
      divText: formatAmount(data?.data?.my_wallet_amount) || 0,
      api: `/wallet/history`,
      bgColor: "rgba(58, 43, 5, 0.45)",
      state: { name: userdata?.name },
    },
    ...(userdata?.role_id == 1
      ? [
          {
            BucketText: "Total Admin Commission",
            divText: formatAmount(data?.data?.total_admin_commission) || 0,
            api: `/wallet/history?wallet_type=2&type=Credit&role_type=1`,
            bgColor: "rgba(11, 92, 45, 0.45)", // Green
          },
        ]
      : []),
    ...(userdata?.role_id == 1
      ? [
          {
            BucketText: "Total All Master Commission",
            divText: formatAmount(data?.data?.total_all_user_commission) || 0,
            api: `/wallet/history?wallet_type=2&type=Credit&role_type=2,3,4`,
            bgColor: "rgba(46, 204, 113, 0.45)", // Green
          },
        ]
      : []),
    {
      BucketText: "Total Commission",
      divText: formatAmount(data?.data?.total_commission) || 0,
      api: `/wallet/history?wallet_type=2&type=Credit`,
      bgColor: "rgba(46, 204, 113, 0.45)", // Green
    },
    {
      BucketText: "Todays Commission",
      divText: formatAmount(data?.data?.todays_commission) || 0,
      api: `/wallet/history?wallet_type=2&date=${today}&type=Credit`,
      bgColor: "rgba(9, 68, 33, 0.45)", // Green
    },

    ...(userdata?.role_id === 1
      ? [
          {
            BucketText: "Total Wallet Amount",
            divText: formatAmount(data?.data?.total_wallet_amount) || 0,
            api: "/wallet/history",
            bgColor: "rgba(75, 192, 192, 0.45)",
          },
        ]
      : []),

    {
      BucketText: "Requested Withdraws",
      divText: formatAmount(data?.data?.total_requested_withdraw) || 0,
      api: `/wallet/request`,
      bgColor: "rgba(241, 141, 40, 0.45)", // Orange
    },

    ...(userdata?.role_id === 1
      ? [
          {
            BucketText: "Total Super Super Master Amount",
            divText:
              formatAmount(data?.data?.total_super_super_master_amount) || 0,
            api: "/wallet/history?role_type=2",
            bgColor: "rgba(89, 230, 108, 0.45)",
          },
        ]
      : []),
    ...(userdata?.role_id === 1
      ? [
          {
            BucketText: "Total Super Master Amount",
            divText: formatAmount(data?.data?.total_super_master_amount) || 0,
            api: "/wallet/history?role_type=3",
            bgColor: "rgba(224, 91, 236, 0.45)",
          },
        ]
      : []),
    ...(userdata?.role_id === 1
      ? [
          {
            BucketText: "Total Master Amount",
            divText: formatAmount(data?.data?.total_master_amount) || 0,
            api: "/wallet/history?role_type=4",
            bgColor: "rgba(50, 51, 75, 0.45)",
          },
        ]
      : []),

    ...(userdata?.role_id === 1
      ? [
          {
            BucketText: "Total Customer Amount",
            divText: formatAmount(data?.data?.total_customer_amount) || 0,
            api: "/wallet/history?role_type=5",
            bgColor: "rgba(231, 76, 110, 0.45)",
          },
        ]
      : []),
    {
      BucketText: "Todays Deposits",
      divText: formatAmount(data?.data?.todays_deposite_money) || 0,
      api: `/wallet/history?wallet_type=3,9&date=${today}`,
      bgColor: "rgba(49, 19, 109, 0.45)",
    },
    {
      BucketText: "Cash Deposit",
      divText: formatAmount(data?.data?.total_cash_deposite_money) || 0,
      api: `/wallet/history?wallet_type=9`,
      bgColor: "rgba(231, 10, 202, 0.45)",
    },

    {
      BucketText: "Online Deposit",
      divText: formatAmount(data?.data?.total_online_deposite_money) || 0,
      api: `/wallet/history?wallet_type=3`,
      bgColor: "rgba(125, 67, 241, 0.45)",
    },

    {
      BucketText: "Total Deposits",
      divText: formatAmount(data?.data?.total_deposite_money) || 0,
      api: "/wallet/history?wallet_type=3",
      bgColor: "rgba(153, 102, 255, 0.45)", // Purple
    },

    {
      BucketText: "Todays Withdraws",
      divText: formatAmount(data?.data?.todays_withdraw_money) || 0,
      api: `/wallet/accept?date=${today}`,
      bgColor: "rgba(117, 67, 17, 0.45)", // Orange
    },

    {
      BucketText: "Cash Withdraws",
      divText: formatAmount(data?.data?.total_cash_withdraw_money) || 0,
      api: `/wallet/history?wallet_type=10`,
      bgColor: "rgba(216, 137, 57, 0.45)", // Orange
    },
    {
      BucketText: "Online Withdraws",
      divText: formatAmount(data?.data?.total_online_withdraw_money) || 0,
      api: `/wallet/history?wallet_type=12`,
      bgColor: "rgba(95, 79, 63, 0.45)", // Orange
    },

    {
      BucketText: "Total Withdraws",
      divText: formatAmount(data?.data?.total_withdraw_money) || 0,
      api: `/wallet/history?wallet_type=1,10,12`,
      bgColor: "rgba(93, 243, 6, 0.45)", // Orange
    },
  ];

  if (data?.data?.customers_wallet) {
    bucketData.unshift({
      BucketText: "Total Customers Wallet Balance",
      divText: data?.data?.customers_wallet || 0,
      api: "/dashboard",
    });
  }

  if (data?.data?.agents_wallet) {
    bucketData.unshift({
      BucketText: "Total Agents Wallet Balance",
      divText: data?.data?.agents_wallet || 0,
      api: "/dashboard",
    });
  }

  if (data?.data?.total_agency_balance) {
    bucketData.unshift({
      BucketText: "Total Justbooking Balance",
      divText: data?.data?.total_agency_balance || 0,
      api: "/dashboard",
    });
  }
  return (
    <section className="Dashboard">
      <Heading_Holder headingText={"Dashboard"} />
      <div className="row mb-5 justify-content-center">
        {bucketData.map((bucket, index) => (
          <div
            key={index}
            className="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4 mt-3">
            <Link
              to={bucket?.api}
              state={bucket?.state}
              style={{ textDecoration: "none" }}>
              <div className="buckets-holder">
                <Buckets
                  BucketText={bucket.BucketText}
                  divText={bucket.divText}
                  bgColor={bucket.bgColor}
                />
              </div>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Dashboard;
